import React from "react";

import styled from "styled-components/macro";

export default function NameWithProfileLink({ userID, name }) {
  const openUserProfile = () => window.fnReactBus.loadUserProfile(userID);

  const nameToDisplay = name && name.trim() ? name.trim() : "No Name Provided";

  return (
    <Span
      className={"can_mini_profile can_mini_profile_" + userID}
      data-userid={userID}
      onClick={openUserProfile}
    >
      {nameToDisplay}
    </Span>
  );
}

const Span = styled.span`
  cursor: pointer;
`;
